import { useEffect, useState } from "react";
import { replace, useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import axios from "axios";
import Loading from "../common/Loading";
import Modal from "../common/Modal";


function Process(){
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [modal, setModal] = useState({
      title:"",
      content:"",
      onConfirmClickHandler:null
    });
    const [searchParams] = useSearchParams();
    const paymentKey = searchParams.get("paymentKey");
    const orderId = searchParams.get("orderId");
    const amount = searchParams.get("amount");
    const navigate = useNavigate();
    useEffect(() => {
        if(paymentKey && orderId && amount){
            confirmPayment();
        }
    }, [paymentKey, orderId, amount])

    const confirmPayment = async() => {
        try {
            const response = await axios.post(
              'https://us-central1-bookstartup-cddce.cloudfunctions.net/approvePayment',
              {
                paymentKey,
                orderId,
                amount,
              }
            );
            if(response.status === 200){
                console.log("결제 성공");
                navigate("/success", {state:{id:orderId, paymentKey:paymentKey}}, {replace:true});
            }
          } catch (error) {
            setModal({
              title:"ERROR",
              content:error.response.data.error.message,
              onConfirmClickHandler:() => navigate("/cart")
            })
            setIsOpenModal(true);
          }
    }
    return(
        <Container>
          <Modal isOpen={isOpenModal} title={modal.title} content={modal.content} onClose={modal.onConfirmClickHandler}/>
          <Loading isOpen={true} title={"처리중 입니다... 잠시만 기다려 주세요"}/>
        </Container>
    )
}

const Container = styled.div`
`
export default Process;